import { AppBackdrop } from './src/AppBackdrop.js';

window.customElements.define('app-backdrop', AppBackdrop);
